import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getAllUsers } from './thunks';
import { UsersState } from './types';

export const name = 'contactUs';

const initialState: UsersState = {
  data: null,
  status: 'idle',
};

export const getAllUsersAsync = createAsyncThunk(
  name + '/getAllUsers',
  getAllUsers
);

export const slice = createSlice({
  name: name,
  initialState,
  reducers: {
    clear: (_) => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllUsersAsync.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(getAllUsersAsync.fulfilled, (state, action) => {
        state.status = 'idle';
        state.data = action.payload;
      })
      .addCase(getAllUsersAsync.rejected, (state, action) => {
        state.status = 'failed';
      });
  },
});

export const actions = slice.actions;

export default slice.reducer;
